import {css} from '../../theme/css'
import {spacing, theme} from '../../theme/theme'

export const classes = {
  root: css`
    padding-block-end: ${spacing(3)};

    ${theme.breakpoints.down('sm')} {
      padding-block-end: ${spacing(2)};
    }
  `,
}
